<template>
  <div class="promotion-card__price-summary">
    <div
      v-if="isCalculating"
      class="promotion-card__price-loader d-flex justify-end mb-1">
      <v-progress-circular indeterminate color="primary" size="16" width="2" />
    </div>
    <div class="promotion-card__price-row align-center">
      <span class="price-label">
        {{ $t('entities.promotions.card.standardPrice') }}
      </span>
      <span>{{ formatCurrency(priceSummary.standardPrice) }}</span>
    </div>
    <div class="promotion-card__price-row align-center">
      <span>{{ $t('entities.promotions.card.discount') }}</span>
      <span>{{ formatCurrency(priceSummary.discountValue) }}</span>
    </div>
    <v-divider />
    <div
      class="promotion-card__price-row promotion-card__price-row--accent align-center mb-0">
      <span>{{ $t('entities.promotions.card.promoPrice') }}</span>
      <span>{{ formatCurrency(priceSummary.promoPrice) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionCardPriceSummary',
  props: {
    priceSummary: { type: Object, required: true },
    arenaCurrency: { type: Object, default: () => ({}) },
    isCalculating: { type: Boolean, default: false },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') {
        return '—'
      }
      const numericValue = Number(value)
      if (Number.isNaN(numericValue)) {
        return value
      }
      const currency =
        this.arenaCurrency?.symbol || this.arenaCurrency?.code || ''
      return `${numericValue.toFixed(2)} ${currency}`
    },
  },
}
</script>

<style scoped>
.promotion-card__price-summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #e4e8f0;
  padding: 1rem;
  min-height: 10.75rem;
}

.promotion-card__price-loader {
  min-height: 1.125rem;
}

.promotion-card__price-row {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  color: #4a4f63;
  margin-bottom: 0.7rem;
}

.price-label {
  max-width: 7rem;
}

.promotion-card__price-row--accent {
  margin-top: 1rem;
  color: #1b3c87;
  font-size: 1.1rem;
}
</style>
